import { ConciergeBehaviorSettingsParser } from "@redotech/redo-concierge-settings-common/general";
import { UrlArraySchema } from "@redotech/redo-merchant-agent-knowledge-rpc/common/url-parser";
import { object, string } from "zod";

export const generateConciergeBehavior = {
  name: "generateConciergeBehavior" as const,
  input: object({ text: string().max(100_000), urls: UrlArraySchema }),
  output: ConciergeBehaviorSettingsParser,
};
